import axios from "axios";

const request = axios.create({
  baseURL: systemConfig.serverUrl, //接口地址
  // timeout: 1000 * 60,
});

export const tokenDataKey = "tokenData";
//请求拦截
request.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // console.log("requestFulfilled", config);
  /*if (config.headers.noToken) {
    // 不需要请求token
  } else {
    let tokenData = JSON.parse(sessionStorage.getItem(tokenDataKey));
    config.headers.Authorization = `${tokenData.token_type} ${tokenData.access_token}`;
  }
  delete config.headers.noToken;*/
  config.headers.RequestSource = 'PC';
  return config;
});

//响应拦截
request.interceptors.response.use(
  (response) => {
    
    // console.log("responseFulfilled:", response);
    // token接口
    /*if (response.config.url === "/auth/authentication/login") {
      // 刷新token的字符串失效
      if (response.data.code === 1003) {
        sessionStorage.removeItem(tokenDataKey);
        router.push("/login");
      } else if (response.data.success) {
        // 获取token成功
        sessionStorage.setItem(
          tokenDataKey,
          JSON.stringify(response.data.data)
        );
      }
    }*/
    return response;
  },
  (error) => {
    // console.log("responseRejected:", error);
    // token过期
   
    if (error.response.status === 401) {
      sessionStorage.clear();
      
      // let tokenData = JSON.parse(sessionStorage.getItem(tokenDataKey));
      // refreshToken(tokenData.refresh_token);
    }
    return Promise.reject(error);
  }
);

export default request;
